export default __webpack_public_path__ + "static/footfall-case-study-129d03b2085fa9ed31eba7fd5766a224.webp";